import { useEffect, useMemo, useState } from "react";
import { Container, FormGroup, Grid, Typography } from "@material-ui/core";

import useLogs from "hooks/logs";
import MaskAndValid from "utils/maskAndValid";
import Api from "lib/api/httpRequestHelper";
import HeaderClientes from "components/_refactor/headers/clients";
import LoadingData from "components/Loading/LoadingData";
import NotFound from "components/Texts/NotFound";
import TableSolicitacaoDevolucao from "./components/TableSolicitacaoDevolucao";
import FormSolicitacaoDialog from "./components/FormSolicitacaoDialog";
import ModalVizualizarSolicitacao from "./components/ModalVizualizarSolicitacao";
import FilterCard from "components/_refactor/filter-card";
import { IsMobile } from "utils/is-mobile";
import { IsMobile900 } from "utils/is-mobile";

import AutoCompleteField from "components/_refactor/fields/autocomplete";
import DateField from "components/_refactor/fields/date";
import InputText from "components/_refactor/text/input";

const statusOptions = [
  { value: "ABERTA", label: "Aberta" },
  { value: "APROVADA", label: "Aprovada" },
  { value: "REJEITADA", label: "Rejeitada" },
];

export default function SolicitacaoDevolucao() {
  const [groupName, setGroupName] = useState(null);
  const [groupNameList, setGroupNameList] = useState([]);
  const [loadingGroupName, setLoadingGroupName] = useState(false);

  const [socialName, setSocialName] = useState("");
  const [socialNameList, setSocialNameList] = useState([]);
  const [loadingSocialName, setLoadingSocialName] = useState(false);

  const [cnpj, setCnpj] = useState("");

  const [initialDate, setInitialDate] = useState(null);
  const [finalDate, setFinalDate] = useState(null);
  const [dateInvalid, setDateInvalid] = useState(false);
  const [product, setProduct] = useState("");
  const [invoice, setInvoice] = useState("");
  const [status, setStatus] = useState();

  const [solicitationList, setSolicitationList] = useState([]);
  const [searching, setSearching] = useState(false);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [selectedSolicitation, setSelectedSolicitation] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogType, setDialogType] = useState("");
  const [openVisibilityModal, setOpenVisibilityModal] = useState(false);

  const isMobile900 = IsMobile900();
  const isMobile = IsMobile();

  const itemXS6 = useMemo(() => (isMobile ? 12 : 6), [isMobile]);
  const itemXSResponsive = isMobile ? 12 : isMobile900 ? 6 : 3;

  const itemXSResponsiveXS = isMobile ? 12 : isMobile900 ? 6 : 2;
  const { setLocalStorageApiProblem } = useLogs();

  const handleVerifyDate = () => {
    if (initialDate && finalDate) {
      if (initialDate > finalDate) {
        setDateInvalid(true);
      } else {
        setDateInvalid(false);
      }
    }
  };

  const handleGetEconomicGroupList = async () => {
    setLoadingGroupName(true);

    await Api.get(`econnomical-group`, "commercialstructure", "", true)
      .then((res) => {
        setGroupNameList(res.Result);
        localStorage.setItem(
          "visao360EconomicGroupList",
          JSON.stringify(res.Result)
        );

        if (res.Result.length === 1) {
          setGroupName(res.Result[0].Id);
        }
      })
      .catch((e) => {
        setLocalStorageApiProblem({
          idMenuAccess: "10",
          screen: "Solicitar Devolução",
          problem: `Erro na chamada do endpoint econnomical-group - ${e}`,
        });
      });
    setLoadingGroupName(false);
  };

  const handleGetSocialNameList = async (page = 0) => {
    if (!groupName) {
      return;
    }
    setLoadingSocialName(true);
    await Api.get(
      "store-user",
      "commercialstructure",
      {
        ...(groupName
          ? {
              idGrupoEconomico: groupName.Id,
            }
          : {}),
        page,
        pageSize: 1000,
      },
      true
    )
      .then((res) => {
        if (page === 0) {
          setSocialNameList(res.Result.ListLojas);
        } else {
          setSocialNameList((s) => [...s, ...res.Result.ListLojas]);
        }

        setLoadingSocialName(false);

        if (res.Result.TotalDePaginas > page) {
          handleGetSocialNameList(page + 1);
        }
      })
      .catch((e) => {
        setLoadingSocialName(false);
        setLocalStorageApiProblem({
          idMenuAccess: "10",
          screen: "Solcitar Devolução",
          problem: `Erro na chamada do endpoint store - ${e}`,
        });
      });
  };

  const handleClearFinalDate = () => {
    document.getElementById("#buttonClearFinalDate").click();
  };

  const handleClearInitialDate = () => {
    document.getElementById("#buttonClearInitialDate").click();
  };

  const handleClearFilters = () => {
    setGroupName("");
    setSocialName("");
    setCnpj("");
    setInitialDate(null);
    setFinalDate(null);
    handleClearInitialDate();
    handleClearFinalDate();
    setProduct("");
    setInvoice("");
    setLoadingGroupName(true);
    setLoadingSocialName(false);
    setTimeout(() => {
      setLoadingGroupName(false);
    }, 500);
  };

  const handleSearch = async () => {
    setSearching(true);

    await Api.get(
      "list-request-reason",
      "trocasDevolucoes",
      "?page=" +
        (page === 0 ? page : page - 1) +
        "&pageSize=25" +
        (groupName ? "&idGrupoEconomico=" + groupName.Id : "") +
        (socialName ? "&idPessoa=" + socialName.Id : "") +
        (cnpj ? "&cnpj=" + cnpj.replace(/\D/g, "") : "") +
        (initialDate ? "&dtIni=" + initialDate : "") +
        (finalDate ? "&dtFim=" + finalDate : "") +
        (product ? "&idProduto=" + product : "") +
        (invoice ? "&numeroNota=" + invoice : "") +
        (status ? "&statusSolicitacao=" + status : ""),
      true
    )
      .then((res) => {
        const pages = Math.ceil(res.Result.TotalRegistros / 25);
        setTotalPages(pages);
        setSolicitationList(res.Result.ListSolicitacao);
      })
      .catch((e) => {
        setLocalStorageApiProblem({
          idMenuAccess: "10",
          screen: "Solcitar Devolução",
          problem: `Erro na chamada do endpoint store - ${e}`,
        });
      })
      .finally(() => {
        setSearching(false);
      });
  };

  useEffect(() => {
    if (page > 0) {
      handleSearch();
    }
  }, [page]);

  useEffect(() => {
    handleGetEconomicGroupList();
    handleSearch();
  }, []);

  useEffect(() => {
    handleGetSocialNameList();
  }, [groupName]);

  useEffect(() => {
    handleVerifyDate();
  }, [initialDate, finalDate]);

  return (
    <div>
      <HeaderClientes
        section="Gestão de solicitação de devolução"
        subsection="Gerenciamento"
      />
      <Container style={{ marginTop: "-4rem" }} maxWidth={false}>
        <FilterCard
          handleSearch={handleSearch}
          disabled={searching}
          searching={
            loadingGroupName ||
            loadingSocialName ||
            searching ||
            (groupName && !socialName)
          }
          handleClearFilters={handleClearFilters}
          bottonInfo={
            <>
              {groupName && !socialName && (
                <Typography
                  variant="h5"
                  component="h5"
                  style={{ color: "grey", marginTop: "1rem" }}
                >
                  <i
                    className="fa fa-exclamation-circle"
                    aria-hidden="true"
                    style={{
                      fontSize: "1rem",
                      marginRight: "0.5rem",
                    }}
                  />{" "}
                  É necessário selecionar uma Razão Social / Loja para realizar
                  a pesquisa.
                </Typography>
              )}

              {dateInvalid && (
                <Typography
                  variant="h5"
                  component="h5"
                  style={{ color: "grey", marginTop: "1rem" }}
                >
                  <i
                    className="fa fa-exclamation-circle"
                    aria-hidden="true"
                    style={{
                      fontSize: "1rem",
                      marginRight: "0.5rem",
                    }}
                  />{" "}
                  A data final é menor que a data inicial.
                </Typography>
              )}
            </>
          }
        >
          <Grid item xs={itemXSResponsive} style={{ marginBottom: "0" }}>
            <AutoCompleteField
              label="Nome do Grupo"
              onChange={(value) => {
                if (value === "all") {
                  setGroupName(null);
                  setSocialName("");
                  setCnpj("");
                  setSocialNameList([]);
                } else {
                  setGroupName(value);
                  setSocialName("");
                }
              }}
              options={groupNameList}
              disabled={groupNameList.length === 1}
              loading={loadingGroupName}
              value={
                groupName ?? groupNameList?.length === 1 ?? groupNameList[0]
              }
            />
          </Grid>

          <Grid item xs={itemXS6} style={{ marginBottom: "0" }}>
            <AutoCompleteField
              label="Razão Social / Loja"
              onChange={(value) => {
                if (value === "all") {
                  setCnpj("");
                  setSocialName("");
                } else {
                  setCnpj(MaskAndValid.maskCNPJ(value.CNPJ));
                  setSocialName(value);
                }
              }}
              options={socialNameList}
              disabled={loadingSocialName}
              loading={loadingGroupName || loadingSocialName}
              value={socialName}
            />
          </Grid>

          <Grid item xs={itemXSResponsive}>
            <InputText
              label="CNPJ"
              placeholder="00.000.000/0000-00"
              value={cnpj}
              onChange={(e) => {
                setCnpj(MaskAndValid.maskCNPJ(e.target.value));
              }}
              disable={loadingSocialName || loadingGroupName}
            />
          </Grid>

          <Grid item xs={itemXSResponsiveXS}>
            <FormGroup data-tut="reactour__step4">
              <DateField
                label="Data Início"
                disabled={loadingSocialName || loadingGroupName}
                value={initialDate}
                onChange={(value) => {
                  setInitialDate(value);
                }}
                required={false}
              />
            </FormGroup>
          </Grid>

          <Grid item xs={itemXSResponsiveXS}>
            <FormGroup data-tut="reactour__step5">
              <DateField
                label="Data Fim"
                disabled={loadingSocialName || loadingGroupName}
                value={finalDate}
                onChange={(value) => {
                  setFinalDate(value);
                }}
                required={false}
              />
            </FormGroup>
          </Grid>

          <Grid item xs={itemXSResponsive}>
            <InputText
              label="Código Produto"
              value={product}
              onChange={(e) => {
                setProduct(e.target.value).slice(0, 200);
              }}
              disable={loadingSocialName || loadingGroupName}
            />
          </Grid>

          <Grid item xs={itemXSResponsive}>
            <InputText
              label="Nota Fiscal"
              value={invoice}
              onChange={(e) => {
                setInvoice(e.target.value).slice(0, 10);
              }}
              disable={loadingSocialName || loadingGroupName}
            />
          </Grid>

          <Grid item xs={itemXSResponsiveXS}>
            <AutoCompleteField
              label="Status"
              onChange={(e) => {
                setStatus(e.target.value);
              }}
              options={statusOptions}
              loading={loadingSocialName || loadingGroupName}
              value={statusOptions.find((s) => s.value === status) ?? null}
            />
          </Grid>
        </FilterCard>

        {searching ? (
          <Grid item xs={12}>
            <LoadingData
              searching={searching}
              label="Buscando dados..."
              hiddenIcon={true}
            />
          </Grid>
        ) : (
          <Grid item xs={12}>
            {solicitationList.length > 0 ? (
              <TableSolicitacaoDevolucao
                solicitacoesDevolucao={solicitationList}
                onApprove={() => {
                  setOpenDialog(true);
                  setDialogType("accept");
                }}
                onReject={() => {
                  setOpenDialog(true);
                  setDialogType("reject");
                }}
                setPage={setPage}
                totalPages={totalPages}
                setSelectedSolicitation={setSelectedSolicitation}
                setOpenVisibilityModal={setOpenVisibilityModal}
              />
            ) : (
              <NotFound
                title={"Desculpa"}
                subtitle={"Sua busca não encontrou resultados"}
              />
            )}
          </Grid>
        )}

        {openDialog && (
          <FormSolicitacaoDialog
            type={dialogType}
            open
            onClose={() => {
              setOpenDialog(false);
              setDialogType("");
            }}
            solicitacao={selectedSolicitation}
            handleSearch={handleSearch}
          />
        )}

        {openVisibilityModal && (
          <ModalVizualizarSolicitacao
            solicitacao={selectedSolicitation}
            handleClose={() => setOpenVisibilityModal(false)}
          />
        )}
      </Container>
    </div>
  );
}
